import { AttributeFieldProps } from "./RenderAttributeInput";
import {  GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import FileUpload from "../../Controls/FileUpload.jsx"
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { AlertConfirm, DestructiveConfirmation } from "../ConfirmationPopups";
import  { unmountComponentAtNode } from "react-dom";
import { UploadImage} from "../Utilities/FileUploadUtility";
import VGPopUp from "../../Controls/VGPopUp.jsx";
import ReactDOM from "react-dom";
import UnsplashMenu from "../UnsplashMenu";
import { adminLogoData } from "../Utilities/PageDataHandler";
import { GetBusinessGallery } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import Accordian from "../Accordian";
import { LinkToEditInVagaroFromLink } from "./LinkToEditInVagaro";


const maxNumOfImages = 50;

const GalleryImageCache = {
    imageURLS:[],
    hasLoaded:false
}

export default function ImageField({label,definition,layoutObject,updateFunc,screenSize,siteData}:AttributeFieldProps){

    let currentImage = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize,"");

    const isURL = definition.attKey == attributeTypes.backgroundImage
    if(isURL && currentImage.includes("url(")){
        currentImage = currentImage.replace("url(","").replace(")","");
    }

    const scrollRef = useRef<HTMLDivElement>(null);
    const multiLimit =  definition.range.max >1 ? definition.range.max:1;
    let imageList = (currentImage!="")?currentImage.split(","):[];

    let inImages = [...siteData.imageUrls];
    const [galleryImages,setGalleryImages] = useState<string[]>(GalleryImageCache.imageURLS);
    const [loadingGallery,setLoadingGallery] = useState(!GalleryImageCache.hasLoaded);

    if(imageList.length>0){
    for(let i = 0;i<imageList.length;i++){

            if(!inImages.includes(imageList[i])){
                inImages.push(imageList[i]);

            }
     }
    }
    else if(currentImage && !inImages.includes(currentImage)){
        inImages.push(currentImage);
    }




    const [images,setImageState] = useState(inImages);

    const [isDeleting,setIsDeleteting] = useState(false);

    const deleteImageByIndex = (index:number)=>{

        if(siteData!=null){

            siteData.imageUrls.splice(index,1);

            siteData.isStyleSaveDirty = true;
            siteData.isStylePublishDirty = true;

            setImageState([...siteData.imageUrls]);
        }
    }

    useEffect(() => {
        if (!GalleryImageCache.hasLoaded) {

            GetBusinessGallery(
                siteData.userContext,
                (response: any) => {
                    const photoDetails = response?.records?.photoDetail;

                    const images = photoDetails
                        .filter((item: any) => item && item.photoUrl)
                        .map((item: any) => {
                            const url = item.photoUrl;
                            // Handle path modification only when processing from API
                            return url.startsWith('http')
                                ? (item.styleID !== "U2FsdGVkX18EI4k80FtcVtq4PzxA94OPqaGqyI1vxNM="
                                    ? url.replace("/Original/", "/Style/Original/")
                                    : url)
                                : `${siteData.cdnUrl}Websitebuilder/${url}`;
                        })
                        .filter((url: any): url is string => typeof url === 'string' && url.length > 0);
                    setGalleryImages(images);
                    GalleryImageCache.hasLoaded = true;
                    GalleryImageCache.imageURLS = images;
                    setLoadingGallery(false);

                },
                (error: any) => {
                    GalleryImageCache.hasLoaded = true;
                    GalleryImageCache.imageURLS = [];
                    console.error('Error fetching gallery:', error);
                    setLoadingGallery(false);

                }
            );


        }



    }, []);

    const onSelect = (imageURL:string,index:number)=>{


        if(imageList.length>=maxNumOfImages){
            AlertConfirm("Maximum image limit reached, please remove unsuded images and try again","max-img-lmt","Maxium Image Limit");

            return;

        }

        const indexOf = imageList.indexOf(imageURL);
        if(indexOf>=0){
            imageList.splice(indexOf,1);
        }
        else{
            if(imageList.length>=multiLimit){
                imageList.shift();
            }

            imageList.push(imageURL);
        }

        let newImageList = imageList.join(",");

        if(isURL && newImageList!=""){
            if(!newImageList.includes("var(--image-"))
                newImageList = "url("+newImageList+")";
        }



        setImageState([...siteData.imageUrls]);

        updateFunc(definition.attKey,newImageList,definition.targetType)

    }


    const searchUnsplash = ()=>{

        const PopupClose = () => {
            let dom = document.getElementById("OpenDialog");
            if (dom) unmountComponentAtNode(dom);
            siteData.designer?.forceUpdate();

        };

        const onAddImage = (imageURL:string)=>{

            PopupClose();
            if(!siteData.imageUrls.includes(imageURL)){
                siteData.imageUrls.push(imageURL);
                siteData.isStyleSaveDirty = true;
                siteData.isStylePublishDirty = true;
            }
            setImageState([...siteData.imageUrls]);
            onSelect(imageURL,siteData.imageUrls.indexOf(imageURL));
        }


        setTimeout(()=>{
            let dom = document.getElementById("unsplash-search");
            if (dom) dom.focus();

        },100)

        const dom =  document.getElementById("OpenDialog");

        ReactDOM.render(
            <>
            <VGPopUp
              id={"unsplash-popup"}
              show={true}
              onHide={PopupClose}
              title={<div className="flex-row align-center gap-med">Search Online Library  <PoweredByUnsplash/>
              </div>}
              dialogClassName="block-edit"
              body={
                <div className="alertContent">
                  <UnsplashMenu userContext={siteData.userContext} onSelect={(onAddImage)}/>
                </div>
              }
              footer={
                <Fragment>

                <button className="w-button w-button-secondary" onClick={(e) => { PopupClose();}}>Cancel</button>
                </Fragment >
              }
              isRemoveTabModalIndex={false}
              isShowFooter={true}
              size={"modal-sm"}
              backdrop={true}
            />

            </>,
            dom);

    }



    const ImageItem = useCallback( ({imageURL,realURL,clickFunc,selected,deleteFunc}:{imageURL:string,realURL:string,deleteFunc?:()=>void,clickFunc:()=>void,selected:number})=>{

        const doesExisit = siteData.imageUrls.includes(realURL)|| galleryImages.includes(realURL);



        const isLogo = imageURL === siteData.logoUrl||imageURL === adminLogoData.imagePath;
        const isMapped = imageURL.includes("var(--image-");

        if(isMapped){

            let index = parseInt(imageURL.replace("var(--image-","").replace(")",""));


            if(!isNaN(index)&&index>=0){
                imageURL = siteData.userContext.imageMapping[index-1];

            }
        }

        return (

                <>
                {isDeleting &&deleteFunc&&!isLogo&&!isMapped?
                        <button  className={selected?"selected":""} style={{backgroundImage:`url(${imageURL})`}} onClick={ deleteFunc}>
                        <DeleteStateIcon />
                        </button>
                        :
                        <>
                           <button  className={(selected?"selected":"")+(isLogo?" img-is-logo":"") + (doesExisit?" ":"removed")} style={{backgroundImage:`url(${imageURL})`}} onClick={ ()=>{ clickFunc()}}>
                {selected>=0 && multiLimit==1 && <SelectedIcon/>}
                {selected>=0 && multiLimit>1 && <SelectedNumberIcon number={selected}/>}
                </button>{
                deleteFunc && !isLogo && !isMapped  &&
                <DeleteImageDom clickFunc={deleteFunc}/>
                }
                </>

                }
                </>

        )
    },[isDeleting,siteData.imageUrls,galleryImages]);

    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/"):("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");

    return (
    <>
    <div className="wb-input-group">

           <div className="flex-row justify-between align-center">
           <label className={currentImage==""?"not-updated":"updated"}>{label}</label>
           <div
           onClick={()=>{searchUnsplash()}}

           style={{color:"var(--input-selected-primary",cursor:"pointer"}} className="font-small">
           <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="currentColor"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
            &nbsp;
            Search Online Library </div>
           </div>
            <div className="image-menu" ref={scrollRef} >

            <div className="image-container add" >


                    <button className="add-image-upload">
                    <FileUpload

                                height={3500}
                                width={3500}
                                allowFlexibleSize = {true}
                                setLoading = {()=>{}}
                                Message="Maximum Width and Height required 3500X3500"
                                ValidFileExtensionMessage="Upload a PNG, or JPG"
                                FileExtension="/(png|jpg|jpeg|PNG|JPG|JPEG)$/i"
                                savecdn = {(filename:any,base64:any,divMain:any,fileDetails:any)=>{


                                    if(siteData.designer){ // show loading
                                        siteData.designer.toggleLoading(true);
                                    }

                                    const onComplete = ()=>{ // disable loading on complete
                                        if(siteData.designer){

                                            siteData.designer.toggleLoading(false);
                                        }
                                    }

                                    const onSuccess = (data:any)=>{
                                       if(data ){

                                            const url = (siteData.userContext.isAdmin)?cardImgPath + siteData.userContext.layoutId+"/"+data   :siteData.cdnUrl +"Websitebuilder/"+ data;

                                            siteData.imageUrls.push(url);
                                            siteData.isStyleSaveDirty = true;
                                            siteData.isStylePublishDirty = true;
                                            setImageState([...siteData.imageUrls]);
                                            onSelect(url,siteData.imageUrls.length-1);
                                       }

                                    }

                                    const onError = ()=>{

                                        if(siteData.designer){
                                            siteData.designer.toggleLoading(false);
                                        }

                                        AlertConfirm("Error Uploading Image, Please Try Reducing your Image Dimensions (1200 X 1200 or less is recommended)","upload-error","Upload Error");
                                    }

                                    if(imageList.length>=maxNumOfImages){
                                        AlertConfirm("Maximum image limit reached, please remove unsuded images and try again","max-img-lmt","Maxium Image Limit");
                                        siteData.designer?.toggleLoading(false);
                                        return;

                                    }
                                    UploadImage(siteData.userContext,"Library_" + filename,base64,onSuccess,onError,onComplete,);
                                }}

                    />
                        <div style={{fontSize:"22px",lineHeight:"1em",fontWeight:"700"}}>+</div><div>Add Photo</div></button>
            </div>
            {  multiLimit<=1 && siteData.siteStyling.imageMapping.length>0 && siteData.userContext.isAdmin&& !definition.attKey.includes("logo")&&
                    siteData.siteStyling.imageMapping.map((inurl,index)=>{

                        if(!inurl||inurl.length<1)
                            return <></>
                        const varUrl = "var(--image-"+(index+1)+")";

                       return (
                        <>
                           <div className={"image-container relative "} key={index}  >

                           <ImageItem imageURL={inurl} realURL={inurl} key={varUrl}  clickFunc={()=>{ onSelect(varUrl,-1)}} selected={(imageList.length>0&&imageList[0]===varUrl?1:-1)} />

                           <div className="w-full font-small center-all" style={{position:"absolute",top:"4px",left:"0px",background:"#000000aa",color:"white", textAlign:"center",fontWeight:400,padding:"4px"}}>
                            {`Image ${index+1}`}
                           </div>
                            {/* <button className="relative" style={{backgroundImage:`url(${inurl})`}}>
                                <div className="w-full h-full center-all" style={{position:"absolute",top:"0",left:"0",background:"#00000044",color:"white"}}>
                                    Mapped Image {index+1}
                                </div>

                            </button> */}
                       </div>
                       </>
                       )


                    })
                }


                {images.map((inurl,index)=>{

                    let url = inurl;

                    //use lower rez images when polling from unsplash
                    if(url.includes("unsplash.com"))
                        url = url.replace("w=1080","w=128");

                    const deleteId = ()=>{deleteImageByIndex(index)


                        ; if(isDeleting){setIsDeleteting(false)}};


                    return (
                        <div className={"image-container " + ( imageList.indexOf(url) == index?"":"selected")} key={index+inurl}  >

                        <ImageItem imageURL={url} realURL={inurl} key={url} deleteFunc={()=>{
                            if(siteData.userContext.isAdmin&&siteData.userContext.imageMapping.includes(inurl)){
                                AlertConfirm("Can't delete mapped images, please unmap this image first in site styling")
                            }

                            else
                            DestructiveConfirmation("Are you sure you want to permanantly delete this image?",deleteId,()=>{},"delte-image-confirm","Delete Image","Delete Image")

                        }} clickFunc={()=>{ onSelect(inurl,index)}} selected={imageList.indexOf(inurl)} /> </div>

                    )
                })}




                { multiLimit>1 &&
                    <div className="image-container add" >

                        <button  onClick={()=>{updateFunc(definition.attKey,"",definition.targetType); setImageState([...siteData.imageUrls]);}}><div style={{fontSize:"22px",lineHeight:"1em",fontWeight:"700"}}>&times;</div><div>Clear All</div></button>
                    </div>

                }

                <div className="image-container add" >

                    <button  onClick={()=>{ setIsDeleteting(!isDeleting)  }}><div style={{fontSize:"22px",lineHeight:"1em",fontWeight:"700"}}><DeleteIcon height={16}/></div><div style={{paddingTop:"6px"}}>{(isDeleting)?"Cancel":"Delete"}</div></button>
                </div>

            </div>

            <Accordian extraStyling={{marginTop:"8px"}} label={<div style={{fontSize:"15px"}}>Gallery Images</div>} wrapperClass="wb-input-group no-border" startExpanded={false} observerSizeChanges={true}>
            <div className="image-menu">

                {loadingGallery&&<div style={{fontSize:"14",fontWeight:"normal"}}>Loading Gallery...</div>}
                {!loadingGallery&&galleryImages.map((inurl,index)=>{

                            let url = inurl;

                            //use lower rez images when polling from unsplash
                            if(url.includes("unsplash.com"))
                                url = url.replace("w=1080","w=128");




                            return (
                                <div className={"image-container " + ( imageList.indexOf(url) == index?"":"selected")} key={index+inurl}  >

                                <ImageItem imageURL={url} realURL={inurl} key={url}   clickFunc={()=>{ onSelect(inurl,index+images.length)}}  selected={imageList.indexOf(inurl)} /> </div>

                            )
                            })}

                            {!loadingGallery&&galleryImages.length<=0&&<div className="w-full" style={{fontSize:"14",fontWeight:"normal",textAlign:"center"}}>No Gallery Images Found</div>}

                            </div>
                            <LinkToEditInVagaroFromLink link={"https://vagaro.com/merchants/settings/lookandfeel/photogallery"} />

                    </Accordian>


    </div>
    </>
    );





}

function DeleteImageDom({clickFunc}:{clickFunc:()=>void}){

    return (
        <button className="delete-image-button center-all" onClick={clickFunc}>
            <DeleteIcon/>
        </button>
    )
}

function DeleteIcon({height=14}:{height?:number}){
  return  <svg xmlns="http://www.w3.org/2000/svg" height={height.toString()} viewBox="0 0 14 16" fill="currentColor">
    <path d="M12.8594 3.21875C13.2402 3.21875 13.5625 3.54102 13.5625 3.92188C13.5625 4.33203 13.2402 4.625 12.8594 4.625H12.5078L11.8047 14.1465C11.7168 15.1426 10.9258 15.875 9.92969 15.875H4.04102C3.04492 15.875 2.25391 15.1426 2.16602 14.1465L1.46289 4.625H1.14062C0.730469 4.625 0.4375 4.33203 0.4375 3.92188C0.4375 3.54102 0.730469 3.21875 1.14062 3.21875H3.16211L4.24609 1.60742C4.53906 1.16797 5.06641 0.875 5.62305 0.875H8.34766C8.9043 0.875 9.43164 1.16797 9.72461 1.60742L10.8086 3.21875H12.8594ZM5.62305 2.28125C5.53516 2.28125 5.44727 2.33984 5.41797 2.39844L4.86133 3.21875H9.10938L8.55273 2.39844C8.52344 2.33984 8.43555 2.28125 8.34766 2.28125H5.62305ZM11.1016 4.625H2.86914L3.57227 14.0586C3.60156 14.293 3.80664 14.4688 4.04102 14.4688H9.92969C10.1641 14.4688 10.3691 14.293 10.3984 14.0586L11.1016 4.625Z" />
</svg>
}

function SelectedIcon(){
    return <div className = "center-all w-full h-full" style={{position:"absolute",top:"0",left:"0",background:"#00000044"}}><svg xmlns="http://www.w3.org/2000/svg" height = "32" viewBox="0 0 512 512" fill="white" >
   <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"/></svg>
   </div>
}

function SelectedNumberIcon({number}:{number:number}){

    return <div className = "center-all w-full h-full" style={{position:"absolute",top:"0",left:"0",background:"#00000044"}}>
        <div className="image-select-number center-all">{number+1}</div>
       </div>
    }

function DeleteStateIcon(){
    return <div className = "center-all w-full h-full pulse-opacity " style={{position:"absolute",top:"0",left:"0",background:"#00000088",color:"white"}}>
        <DeleteIcon height={28}/>
   </div>
}


// function DeleteImageConfirmation(index:number,onDelete:Function) {

//     const PopupClose = () => {
//         let dom = document.getElementById("OpenDialog");
//         if (dom) unmountComponentAtNode(dom);

//     };

//         return ReactDom.render(
//           <VGPopUp
//             id={"DeleteUserImage"}
//             show={true}
//             onHide={PopupClose}
//             title={"Confirmation"}
//             dialogClassName="block-edit"
//             body={
//               <div className="alertContent">
//                 <p>Are you sure you want to remove webclip images?</p>
//               </div>
//             }
//             footer={
//               <Fragment>
//                 <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
//                 <button className="w-button w-button-destructive-outline" onClick={(e) => { PopupClose(); onDelete(index)}}>Delete</button>
//               </Fragment >
//             }
//             isRemoveTabModalIndex={false}
//             isShowFooter={true}
//             size={"modal-sm"}
//             backdrop={true}
//           />,
//           document.getElementById("OpenDialog"));
// }

export function PoweredByUnsplash(){
    return  <div className="flex-row font-small">Powered by Unsplash&nbsp;
  <UnsplashIcon/>   </div>
}

export function UnsplashIcon(){
    return  <svg xmlns="http://www.w3.org/2000/svg"fill="currentColor" height="1em" viewBox="0 0 448 512"><path d="M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"/></svg>

}
